<template>
	<sa-page-layout :titolo="titolo" :showmolalloading="showmolalloading" :btnNewVisible="true" :btnRefreshVisible="true" :linkedit="linkedit">
		<template slot="toolbar">
			<b-button class="float-sm-right btn-toolbar" variant="light sa-margin-right" size="sm" @click="onUpdate" v-b-modal.modal-center><b-icon icon="arrow-clockwise" />Aggiorna Modulo</b-button>
		</template>
		<template slot="table-filter"> </template>
		<template slot="table-header">
			<b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
				<b-col cols="6">
					<p>Totale Record: {{ rows }}</p>
				</b-col>
				<b-col cols="6">
					<b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
				</b-col>
			</b-row>
		</template>
		<template slot="table-body">
			<div class="b-table-sticky-header">
				<b-table sticky-header ref="table" id="tblPazienti" :filter="filter" responsive stacked="lg" striped hover :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
					<template #cell(nome)="{ item }">
						<span style="font-weight: bold">{{ item.nome }}</span>
						<span style="padding-left: 0.5rem">({{ item.version }})</span>
					</template>
					<template #cell(actions)="{ item }">
						<b-container class="bv-example-row">
							<b-button size="sm" class="mr-1 ml-1 no-text" variant="outline-primary " @click="onClickInstallaSezioni(item)" v-b-tooltip.hover title="Installa Sezioni">
								<font-awesome-icon icon="copy"> </font-awesome-icon>
							</b-button>
							<b-button size="sm" class="mr-1 ml-1 no-text" variant="outline-primary " @click="onClickUpdate(item)" v-b-tooltip.hover title="Installa Sezioni">
								<i class="fas fa-sync-alt"></i>
							</b-button>
						</b-container>
					</template>
				</b-table>
				<b-modal :title="'Installa Sezioni'" centered no-close-on-backdrop no-close-on-esc hide-header-close size="lg" ref="mdlSezioni" scrollable>
					<div class="b-table-sticky-header">
						<b-table sticky-header ref="table" id="tblSezioni" :filter="filter" :key="listkey" responsive stacked="lg" striped hover :items="jsonDataSezioni" :fields="fieldsSezioni" :current-page="1" :per-page="1000000000" sort-icon-left head-variant="light" class="sa-b-table">
							<template #cell(descrizione)="{ item }">
								<span class="sa.label-data" v-if="item.presente">{{ item.descrizione }}</span>
								<b-form-input v-model="item.descrizione" v-if="!item.presente"></b-form-input>
							</template>
							<template #cell(permessiAssegnati)="{ item }">
								<span class="sa.label-data" v-if="item.presente">{{ item.permessiAssegnati }}</span>
								<b-form-input v-model="item.permessiAssegnati" v-if="!item.presente"></b-form-input>
							</template>
							<template #cell(presente)="{ item }">
								<b-icon icon="circle-fill" scale="2" :class="getClassCircleStato(item.presente)" aria-hidden="true"></b-icon>
							</template>
						</b-table>
					</div>
					<template #modal-footer>
						<b-button size="md" class="no-text" variant="outline-danger" @click="onClickClose">Chiudi</b-button>
						<b-button @click="onClickSave" variant="outline-success">Salva</b-button>
					</template>
				</b-modal>
			</div>
		</template>
		<template slot="table-footer">
			<b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
				<b-col cols="6">
					<p>Totale Record: {{ rows }}</p>
				</b-col>
				<b-col cols="6">
					<b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
				</b-col>
			</b-row>
		</template>
	</sa-page-layout>
</template>
<script>
import moment from "moment";
import axios from "axios";
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
	mixins: [UtilityMixin],
	components: { SaPageLayout },
	computed: {
		rows() {
			return this.items.length;
		},
	},
	data() {
		return {
			titolo: "Parametri",
			showmolalloading: false,
			currentPage: 1,
			perPage: 30,
			filter: "",
			listkey: 0,
			linkedit: "/moduli",
			isBusy: false,
			pathRest: "/application",
			pathResourceCheckSezioni: "/configurazionemoduli/sectionlist",
			pathResourceSezioni: "/configurazionemoduli/sectionadd",
			fields: [
				{
					label: "Nome",
					key: "nome",
					sortable: true,
				},
				{
					label: "Vers.",
					key: "compileDate",
					sortable: true,
					formatter: (value) => {
						if (value) {
							return moment(new Date(value)).format("DD-MM-YYYY HH:mm:ss");
						} else {
							return "";
						}
					},
				},
				{
					label: "jar",
					key: "jar",
					sortable: true,
				},
				{
					label: "Descrizione",
					key: "descrizione",
					sortable: true,
				},
				{
					label: "",
					class: "sa-table-column-action-double",
					key: "actions",
				},
			],
			fieldsSezioni: [
				{
					label: "Descrizione",
					key: "descrizione",
					sortable: true,
				},
				{
					label: "Sezione",
					key: "id",
					sortable: true,
				},
				{
					label: "Pernmessi Assegnati",
					key: "permessiAssegnati",
					sortable: true,
				},
				{
					label: "Presente",
					key: "presente",
					sortable: true,
				},
				// {
				// 	label: "",
				// 	class: "sa-table-column-action-double",
				// 	key: "actions",
				// },
			],
			items: [],
			jsonDataSezioni: [],
			data: [],
			filtro: {},
		};
	},
	created: function () {},
	mounted: function () {
		let me = this;
		me.id = this.$route.params.id;
		me.loadData();
	},
	update: function () {
		console.log("Update");
	},
	methods: {
		loadData() {
			let me = this;
			let link = process.env.VUE_APP_PATH_API + me.pathRest;
			me.isBusy = true;
			me.showmolalloading = true;
			axios.get(link, { params: me.filtro })
				.then((response) => {
					me.items = [];
					me.items = response.data.data;
					me.showmolalloading = false;
				})
				.catch(function (error) {
					me.showmolalloading = false;
					me.$bvToast.toast(error.response.data.messaggio, {
						title: "Sorveglianza Covid Admin",
						variant: "danger",
						solid: true,
					});
				});
		},
		onRefresh() {
			let me = this;
			me.loadData();
		},
		onSubmit: function () {
			let me = this;
			me.loadData();
			return false;
		},
		onUpdate() {},
		onClickInstallaSezioni(item) {
			let me = this;
			me.loadSezioniModulo(item);
			// me.$refs.mdlSezioni.show();
		},
		loadSezioniModulo(item) {
			let me = this;
			me.showmolalloading = true;
			let filtro = { nomeModulo: item.jar };
			UtilityMixin.methods.loadDataResources(me.pathResourceCheckSezioni, filtro, me.loadDataSuccess, me.loadDataError);
		},

		loadDataSuccess(response) {
			let me = this;
			me.jsonDataSezioni = response.data.data;
			me.listkey++;
			me.$refs.mdlSezioni.show();
			me.showmolalloading = false;
		},
		loadDataError(response) {
			let me = this;
			me.showmolalloading = false;
			me.$bvToast.toast("Errore durante il caricamento dei dati", response, {
				title: "Errore",
				variant: "danger",
				solid: true,
			});
		},
		getClassCircleStato(value) {
			if (value) {
				return "text-success";
			} else {
				return "text-danger";
			}
		},
		onClickSave() {
			let me = this;
			me.showmolalloading = true;
			let link = process.env.VUE_APP_PATH_API + me.pathResourceSezioni;
			me.jsonDataSezioni.forEach((element) => {
				if (!element.presente) {
					UtilityMixin.methods.restCallPost(link, element, me.saveSuccess, me.saveErrors);
				}
			});
		},
		saveSuccess() {
			let me = this;
			me.showmolalloading = false;
			me.$refs.mdlSezioni.hide();
			me.jsonDataSezioni = [];
		},
		saveErrors(error) {
			let me = this;
			me.showmolalloading = false;
			this.$bvModal
				.msgBoxOk(error.response.data.messaggio, {
					title: "ATTENZIONE",
					size: "sm",
					okVariant: "outline-danger",
					headerClass: "sa-msg-header-danger",
					footerClass: "p-2 border-top-0",
					centered: true,
				})
				.then((value) => {
					console.log(value);
				})
				.catch((err) => {
					console.log(err);
				});
			this.showModalLoading = false;
		},
		onClickClose() {
			let me = this;
			me.$refs.mdlSezioni.hide();
			me.jsonDataSezioni = [];
		},
		onClickUpdate(item) {
			console.log(item);
			this.loadJarInfo(item);
		},
		loadJarInfo(item) {
			UtilityMixin.methods.loadDataResources("/installation/jarinfo", { jarName: item.jar }, this.loadJarInfoSuccess, this.loadDataError);
		},
		loadJarInfoSuccess(response) {
			console.log(response);
		},
		loadJarInfoError() {},
	},
};
</script>
